module.exports = __webpack_public_path__ + "static/media/bn_banner.85bd3649.png";